import React, { FC, ReactNode, useMemo } from "react";
export interface PriceProps {
  amount?: number | null;
  symbol?: string;
  fallback?: ReactNode;
}

export const Price: FC<PriceProps> = ({ amount, symbol, fallback }) => {
  const value = useMemo(() => {
    if (amount || amount === 0) {
      const inDollars = amount / 100;
      const formatted = inDollars.toLocaleString("en-US", {
        maximumFractionDigits: 2,
      });

      const symbolOrDefault = symbol ?? "$";

      return symbolOrDefault + formatted;
    }

    if (fallback) {
      return fallback;
    }

    return false;
  }, [amount, symbol, fallback]);

  return <>{value}</>;
};
